import { ScaleElement } from '@scale/base-element';

class ScaleAnnouncementBar extends ScaleElement {
  #currentSlide = 0;
  #autoplayInterval;
  #slideItems = [];
  #isPaused = false;
  #onScreen = false;

  setup() {
    if (this.hasAttribute('data-dismissible')) {
      this.#checkDismissed();
    }

    const slides = this.ref('slides');
    if (slides) {
      this.#slideItems = [...slides.children];
      if (this.#slideItems.length > 0) {
        this.#slideItems[0].classList.add('is-active');
      }
      if (this.#slideItems.length > 1) {
        this.onScreen((shown) => {
          this.#onScreen = shown;
          if (shown) this.#startAutoplay();
          else this.#stopAutoplay();
        });

        if (this.hasAttribute('data-pause-on-hover')) {
          this.on('mouseenter', () => {
            this.#isPaused = true;
            this.#stopAutoplay();
          });
          this.on('mouseleave', () => {
            this.#isPaused = false;
            this.#startAutoplay();
          });
        }
      }
    }

    if (this.hasAttribute('data-marquee')) {
      this.#setupMarquee();
    }
  }

  teardown() {
    this.#stopAutoplay();
  }


  next() {
    this.#goTo((this.#currentSlide + 1) % this.#slideItems.length);
    this.#restartAutoplay();
  }

  prev() {
    this.#goTo((this.#currentSlide - 1 + this.#slideItems.length) % this.#slideItems.length);
    this.#restartAutoplay();
  }

  #goTo(index) {
    this.#slideItems[this.#currentSlide]?.classList.remove('is-active');
    this.#slideItems[index]?.classList.add('is-active');
    this.#currentSlide = index;
  }

  #startAutoplay() {
    if (this.#autoplayInterval || this.#isPaused || !this.#onScreen) return;
    const speed = this.getNumber('data-autoplay', 5) * 1000;
    this.#autoplayInterval = setInterval(() => this.next(), speed);
  }

  #stopAutoplay() {
    clearInterval(this.#autoplayInterval);
    this.#autoplayInterval = null;
  }

  #restartAutoplay() {
    this.#stopAutoplay();
    const wasPaused = this.#isPaused;
    this.#isPaused = false;
    this.#startAutoplay();
    this.#isPaused = wasPaused;
  }


  #setupMarquee() {
    const track = this.ref('track');
    const source = this.ref('marquee-source');
    if (!track || !source) return;

    const speed = this.getNumber('data-marquee-speed', 30);
    const marqueeWidth = this.ref('marquee').offsetWidth;
    const groupWidth = source.scrollWidth;

    const copies = Math.ceil(marqueeWidth / groupWidth) + 1;
    for (let i = 0; i < copies; i++) {
      const clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-ref');
      track.appendChild(clone);
    }

    const totalGroups = copies + 1;
    const offset = (-100 / totalGroups).toFixed(4);
    track.style.setProperty('--marquee-offset', `${offset}%`);
    track.style.setProperty('--marquee-duration', `${speed}s`);
  }


  dismiss() {
    const sectionId = this.dataset.sectionId;
    try {
      sessionStorage.setItem(`scale:announcement-dismissed:${sectionId}`, 'true');
    } catch {   }
    this.classList.add('announcement-bar--dismissed');
  }

  #checkDismissed() {
    const sectionId = this.dataset.sectionId;
    try {
      if (sessionStorage.getItem(`scale:announcement-dismissed:${sectionId}`) === 'true') {
        this.classList.add('announcement-bar--dismissed');
      }
    } catch {   }
  }
}

if (!customElements.get('scale-announcement-bar')) {
  customElements.define('scale-announcement-bar', ScaleAnnouncementBar);
}
